import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import ScrollableTooltip from '../scrollableTooltip';

import { ReactComponent as NewTooltipIcon } from '../../../assets/icons/info.svg';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  icon: {
    marginLeft: spacing(1),
    marginRight: spacing(1),
  },
  tooltip: {
    maxWidth: 402,
    width: 402,
    height: 390,
    maxHeight: 390,
    boxShadow: 'none',
    border: `1px solid ${primary.bluish5}`,
    borderRadius: 8,
    left: 51,
  },
  userRoleTooltip: {
    left: 175,
  },
  moderatorRoleTooltip: {
    left: 104,
  },
  hrbpRoleTooltip: {
    left: 30,
  },
  adminRoleTooltip: {
    left: -31,
  },
  associateRoleTooltip: {
    left: -130,
  },
  tooltipViewport: {
    maxHeight: 300,
    height: 300,
    padding: 0,
    marginBottom: 0,
    '& ul': {
      paddingLeft: spacing(8),
      paddingTop: spacing(4),
      margin: 0,
    },
  },
  tooltipHeader: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const RolesPermissionsTooltip = ({ role, roleData, title, order }) => {
  const classes = useStyles();
  const USER_ROLE_TOOLTIP = 1;
  const MODERATOR_ROLE_TOOLTIP = 2;
  const HRBP_ROLE_TOOLTIP = 3;
  const ADMIN_ROLE_TOOLTIP = 4;
  const ASSOCIATE_ROLE_TOOLTIP = 5;

  const renderContent = items => {
    return (
      <Typography component="div" variant="body2">
        <ul>
          {items?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </Typography>
    );
  };

  return (
    <ScrollableTooltip
      tooltipWrapperClass={classNames(classes.tooltip, {
        [classes.userRoleTooltip]: order === USER_ROLE_TOOLTIP,
        [classes.moderatorRoleTooltip]: order === MODERATOR_ROLE_TOOLTIP,
        [classes.hrbpRoleTooltip]: order === HRBP_ROLE_TOOLTIP,
        [classes.adminRoleTooltip]: order === ADMIN_ROLE_TOOLTIP,
        [classes.associateRoleTooltip]: order === ASSOCIATE_ROLE_TOOLTIP,
      })}
      scrollViewportClass={classes.tooltipViewport}
      title={title}
      contentData={roleData}
      renderContent={renderContent}
      isTooltipArrowHidden
    >
      <Typography variant="body2" className={classes.tooltipHeader}>
        {role}
        <NewTooltipIcon className={classes.icon} />
      </Typography>
    </ScrollableTooltip>
  );
};

RolesPermissionsTooltip.propTypes = {
  role: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  roleData: PropTypes.array.isRequired,
  order: PropTypes.number.isRequired,
};

export default RolesPermissionsTooltip;
